import React from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const SkeletonForecastListing = () => {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-borderless">
                <thead>
                    <tr className="mt-3">
                        <th scope="col" className="sort-icon">
                            Mark
                        </th>
                        <th scope="col">Product Group</th>
                        <th scope="col">Model Number</th>
                        <th scope="col" style={{ textAlign: "right" }}>Quantity</th>
                        <th scope="col" style={{ textAlign: "right" }}>Quoted</th>
                        <th scope="col" style={{ textAlign: "right" }}>Forecasted</th>
                        <th scope="col" style={{ textAlign: "right" }}>Order Received</th>
                        <th className="text-center" scope="col">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {[...Array(5)].map((_, index) => (
                        <tr key={index}>
                            <td><Skeleton width={120} height={25} /></td>
                            <td><Skeleton width={150} height={25} /></td>
                            <td><Skeleton width={150} height={25} /></td>
                            <td style={{ textAlign: "right" }}>
                                <Skeleton width={80} height={25} />
                            </td>
                            <td style={{ textAlign: "right" }}>
                                <Skeleton width={100} height={25} />
                            </td>
                            <td style={{ textAlign: "right" }}>
                                <Skeleton width={100} height={25} />
                            </td>
                            <td style={{ textAlign: "right" }}>
                                <Skeleton width={100} height={25} />
                            </td>
                            <td>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Skeleton width={25} height={25} />
                                    <Skeleton width={25} height={25} />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default SkeletonForecastListing;